import * as React from 'react';
import { getCounterValue } from './utils';
import styles from './Counter.module.css';
import { clsx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export var Counter = function Counter(_ref) {
  var counter = _ref.counter,
    counterMaxLength = _ref.counterMaxLength,
    className = _ref.className,
    dataTestId = _ref.dataTestId;
  var counterValue = getCounterValue(counter, counterMaxLength);
  return /*#__PURE__*/_jsx("span", {
    className: clsx(styles['counter'], className),
    "data-testid": dataTestId,
    children: counterValue
  });
};